<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1213 8L32.0416 29.9203L29.9203 32.0416L7.99998 10.1213L10.1213 8Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M32.0416 10.1213L10.1213 32.0416L8 29.9203L29.9203 7.99998L32.0416 10.1213Z"/>
    </g>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 40px;
  height: 40px;

  opacity: 0.5;
  fill: #B9C8D2;

  transition: fill 0.3s;

  cursor: pointer;

  &:hover {
    opacity: 1;
    fill: #FF9393;
  }
}
</style>